import React from "react";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import LanguageSwitcher from "./components/LanguageSwitcher";
import HamburgerMenu from "./components/HamburgerMenu";
import HeroSection from "./components/HeroSection";
import ExecutiveSummarySection from "./components/ExecutiveSummarySection";
import AssetSection from "./components/AssetSection";
import InvestmentThesisSection from "./components/InvestmentThesisSection";
import DevelopmentSection from "./components/DevelopmentSection";
import ExpansionSection from "./components/ExpansionSection";
import RevenueModelSection from "./components/RevenueModelSection";
import OperatorSection from "./components/OperatorSection";
import FounderVisionSection from "./components/FounderVisionSection";
import DealStructureSection from "./components/DealStructureSection";
import ReturnsSection from "./components/ReturnsSection";
import RiskSection from "./components/RiskSection";
import PositioningSection from "./components/PositioningSection";
import LongTermVisionSection from "./components/LongTermVisionSection";
import ContactSection from "./components/ContactSection";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <HamburgerMenu />
        <LanguageSwitcher isDark={true} />
        
        <HeroSection />
        <ExecutiveSummarySection />
        <AssetSection />
        <InvestmentThesisSection />
        <DevelopmentSection />
        <ExpansionSection />
        <RevenueModelSection />
        <OperatorSection />
        <FounderVisionSection />
        <DealStructureSection />
        <ReturnsSection />
        <RiskSection />
        <PositioningSection />
        <LongTermVisionSection />
        <ContactSection />
      </div>
    </LanguageProvider>
  );
}

export default App;
